export type uuid = string;

export enum ValueType {
    TEXT = "461b7650-a352-4670-8bdf-a144e5702448",
    TEXTAREA = "96a70b9c-e794-4c52-883f-d4edd9e73dfd",
    SELECT = "e6bf4f7d-3b46-4569-bdd3-3216f7451354",
    CHECKBOX_GROUP = "5367d5db-a4c5-4d91-ad6e-375ba7c77881",
    DATE = "5464dbd4-c6a6-4008-a7d8-fce92111020e",
    NUMBER = "0076adae-aa49-4817-ba2d-f14ba9c7ff6a",
}

export interface FormQuestionDependency {
    questionMasterGuid: uuid;
    answerValueGuid: uuid;
}

export interface FormQuestionAnswers {
    guid: uuid;
    value: string;
    defaultValue: boolean;
}

export interface FormQuestion {
    text: string;
    description?: string;
    guid: uuid;
    required: boolean;
    questionTypeGuid: ValueType;
    questionDependencies?: FormQuestionDependency[];
    availableResponseValues?: FormQuestionAnswers[];
    userAnswers?: FormQuestionAnswers[];
}

export interface EntityInfo {
    label: string;
    value: string; // May be other than string
}

export interface Form {
    title: string;
    userName?: string;
    userSurname?: string;
    userGuid?: uuid;
    description: string;
    formTypeGuid: uuid;
    entityGuid: uuid;
    questions: FormQuestion[];
    entityInfoList?: EntityInfo[];
}

export interface FormAnswers {
    questions: FormQuestionAnswer[];
}

export interface FormQuestionAnswer {
    questionGuid: uuid;
    value: (string | number)[];
}
